import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import firstone from '../../assets/images/data/Data1.png';
import secondone from '../../assets/images/data/Data2.png';
import thirdone from '../../assets/images/data/Data3.png';
import Paginationn from '../pagination/paginationn';

import './data_styles/datalower.css';

export default function DataLower() {
  return (
    <>
     <Container className='mt-3 mb-3 data_lower'>
      <Row>
        <Col lg={4} md={6} className='mt-3'>
          <div className="card">
          <div className='data_lower_image'>
            <img src={firstone} alt="first one" className='img-fluid rounded data_lower_img' />
            <div className='data_lower_image_div'>
              <span>12/28/2022</span>
            </div>
          </div>
          <div className='d-flex justify-content-start'>
            <p className='text-justify'>The recently popular Internet AI: ChatGPT has actually written: "The Plan to Destroy Humanity"</p>
          </div>
          <a href="">Detail</a>
          </div>
        </Col>
        <Col lg={4} md={6} className='mt-3'>
          <div className="card">
          <div className='data_lower_image'>
            <img src={secondone} alt="second one" className='img-fluid rounded data_lower_img' />
            <div className='data_lower_image_div'>
              <span>12/28/2022</span>
            </div>
          </div>
          <div>
            <p>The recently popular Internet AI: ChatGPT has actually written: "The Plan to Destroy Humanity"</p>
          </div>
          <a href="">Detail</a>
          </div>
        </Col>
        <Col lg={4} md={6} className='mt-3'>
          <div className="card">
          <div className='data_lower_image'>
            <img src={thirdone} alt="third one" className='img-fluid rounded data_lower_img' />
            <div className='data_lower_image_div'>
              <span>12/28/2022</span>
            </div>
          </div>
          <div>
            <p>The recently popular Internet AI: ChatGPT has actually written: "The Plan to Destroy Humanity"</p>
          </div>
          <a href="">Detail</a>
          </div>
        </Col>
      </Row>
      <Row>
        <Col lg={4} md={6} className='mt-3'>
          <div className="card">
          <div className='data_lower_image'>
            <img src={firstone} alt="first one" className='img-fluid rounded data_lower_img' />
            <div className='data_lower_image_div'>
              <span>12/28/2022</span>
            </div>
          </div>
          <div className='d-flex justify-content-start'>
            <p className='text-justify'>The recently popular Internet AI: ChatGPT has actually written: "The Plan to Destroy Humanity"</p>
          </div>
          <a href="">Detail</a>
          </div>
        </Col>
        <Col lg={4} md={6} className='mt-3'>
          <div className="card">
          <div className='data_lower_image'>
            <img src={secondone} alt="second one" className='img-fluid rounded data_lower_img' />
            <div className='data_lower_image_div'>
              <span>12/28/2022</span>
            </div>
          </div>
          <div>
            <p>The recently popular Internet AI: ChatGPT has actually written: "The Plan to Destroy Humanity"</p>
          </div>
          <a href="">Detail</a>
          </div>
        </Col>
        <Col lg={4} md={6} className='mt-3'>
          <div className="card">
          <div className='data_lower_image'>
            <img src={thirdone} alt="third one" className='img-fluid rounded data_lower_img' />
            <div className='data_lower_image_div'>
              <span>12/28/2022</span>
            </div>
          </div>
          <div>
            <p>The recently popular Internet AI: ChatGPT has actually written: "The Plan to Destroy Humanity"</p>
          </div>
          <a href="">Detail</a>
          </div>
        </Col>
        <div className="mt-5">
            <Paginationn />
        </div>
      </Row>
     </Container>
    </>
  )
}
